import { sendAction } from "@/core/action";

export function earlyWebContentLoading(url: string) {
    return sendAction({
        actionId: 'earlyWebContentLoading',
        url,
    });
}